import React from 'react';
import { useFormContext } from 'react-hook-form';
import Consent from 'common-mui/components/Consent';

const InputConsent = ({ label, required }) => {
  const { control } = useFormContext();
  return (
    <Consent
      control={control}
      consentLabel={label}
      required={required}
    />
  );
};

export default InputConsent;
